import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

/**
 * トップページ　Pickupスライダー
*/
const pickupSlider = () => {

    // data属性で指定されたトリガーを取得
    const triggerList = document.querySelectorAll('.js_pickupSlider');
    // 上記クラスがなければ終了
    if (!triggerList.length) return;

    const swiper = new Swiper('.js_pickupSlider', {
        spaceBetween: 15,
        allowTouchMove: true,
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: '.bl_pickupSlider .swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            750: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
        on: {
            init: function() {
                // 初期化時にページネーションの表示/非表示を制御
                updatePaginationVisibility(this);
            },
            resize: function() {
                // リサイズ時にページネーションの表示/非表示を制御
                updatePaginationVisibility(this);
            }
        }
    });

    // ページネーションの表示/非表示を制御する関数
    function updatePaginationVisibility(swiperInstance) {
        const paginationEl = document.querySelector('.bl_pickupSlider .swiper-pagination');
        if (!paginationEl) return;

        const isDesktop = window.innerWidth >= 750;
        const totalSlides = swiperInstance.slides.length;
        
        if ((isDesktop && totalSlides <= 3) || (!isDesktop && totalSlides < 2)) {
            // デスクトップでスライドが3枚以下の場合、またはモバイルでスライドが2枚未満の場合はページネーションを非表示
            paginationEl.style.display = 'none';
        } else {
            // それ以外の場合はページネーションを表示
            paginationEl.style.display = 'flex';
        }
    }
}

export default pickupSlider;